import {
  Segmented as _Segmented,
  SegmentedProps as _SegmentedProps,
} from 'antd'

import './Segmented.css'

export type SegmentedProps = _SegmentedProps
export default function Segmented({ className, ...props }: SegmentedProps) {
  return (
    <_Segmented
      className={`segmented ${className}`}
      {...props}
    />
  )
}
